import React from 'react';
import styled from 'styled-components';
import { Section, Container, SectionTitle, MarkdownContent, SectionDescription } from '../../components/Section';

const BadgeWrap = styled.div`
	display: flex;
	align-items: center;
	flex-wrap: wrap;	
	margin:0 -5px;
`
const Badge = styled.div`
	margin:5px;
	padding: 5px 15px;
	width: fit-content;
	border: 1px solid #b5b5b5;
	border-radius: 20px;
	font-weight:700;	
`

const AvailableSection = ({ data }) => (
	<Section>
		<Container>
			<MarkdownContent textAlign="left"  dangerouslySetInnerHTML={{__html: data.description.childMarkdownRemark.html}} />
			{data.sizes?.length > 0 && (
				<>
					<SectionDescription textAlign="left"><p>{data.title}</p></SectionDescription>
					<BadgeWrap>
					{
						data.sizes.map((item, i) => (
							<Badge key={`size-${i}`}>{item.content}</Badge>
						))
					}
					</BadgeWrap>
				</>
			)}
			
		</Container>
	</Section>
);

export default AvailableSection;